var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoticeWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.4375 5.8125C8.4375 5.50184 8.68934 5.25 9 5.25C9.31066 5.25 9.5625 5.50184 9.5625 5.8125V9.1875C9.5625 9.49816 9.31066 9.75 9 9.75C8.68934 9.75 8.4375 9.49816 8.4375 9.1875V5.8125Z",
    fill: "#B75511"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 12.375C9.41421 12.375 9.75 12.0392 9.75 11.625C9.75 11.2108 9.41421 10.875 9 10.875C8.58579 10.875 8.25 11.2108 8.25 11.625C8.25 12.0392 8.58579 12.375 9 12.375Z",
    fill: "#B75511"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 16.5C13.1421 16.5 16.5 13.1421 16.5 9C16.5 4.85786 13.1421 1.5 9 1.5C4.85786 1.5 1.5 4.85786 1.5 9C1.5 13.1421 4.85786 16.5 9 16.5ZM9 15.6C12.6451 15.6 15.6 12.6451 15.6 9C15.6 5.35492 12.6451 2.4 9 2.4C5.35492 2.4 2.4 5.35492 2.4 9C2.4 12.6451 5.35492 15.6 9 15.6Z",
    fill: "#B75511"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoticeWarning);
export default __webpack_public_path__ + "static/media/NoticeWarning.46bbed7a0980b6f0391bc47e093c18ea.svg";
export { ForwardRef as ReactComponent };